var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ft14 ftw500 cl-placeholder",staticStyle:{"cursor":"pointer"},style:(_vm.djs == _vm.t ? _vm.colorStyle : ''),on:{"click":_vm.djsIng}},[_vm._v(_vm._s(_vm.getText))])}
var staticRenderFns = []

export { render, staticRenderFns }